<mat-card appearance="outlined" *ngIf="shouldRenderComponent">
  <mat-card-header>
    <mat-card-title>{{ 'packsTexts.orderPayment' | translate }}</mat-card-title>
  </mat-card-header>

  <mat-card-content class="container input">

    <h2 *ngIf="!showMPIResponse">{{ 'packsTexts.orderInfo' | translate}} {{orderNumber}}</h2>

    <div class="row" *ngIf="!showMPIResponse">
      <div class="col-md-3"><strong>{{ 'packsTexts.serviceName' | translate }}:</strong></div>
      <div class="col-md-3">{{ packInfo.name[lang] }}</div>
      <div class="col-md-3"><strong>{{ 'packsTexts.orderPrice' | translate }}:</strong></div>
      <div class="col-md-3">
        <ng-container *ngIf="packData.order?.currencyCode">
          <span [ngClass]="{ 'hide': packData.order.currencyCode === 'BGN' }"
            *ngIf="packData.order.currencyCode === 'BGN'">
            {{ packData.order.price | localizedCurrency }} / {{ (packData.order.price / 1.95583) | currency:'EUR':'symbol':'1.2-2':'de-DE' }}
          </span>
          <span *ngIf="packData.order.currencyCode === 'EUR'">
            {{ packData.order.price | currency:'EUR':'symbol':'1.2-2':'de-DE'}} / {{ (packData.order.price * 1.95583) | currency:'BGN':'symbol':'1.2-2':'bg-BG' }}
          </span>
        </ng-container>
      </div>
    </div>
    <div class="row" *ngIf="!showMPIResponse">
      <div class="col-md-3"><strong>{{ 'packsTexts.amountPayments' | translate }}:</strong></div>
      <div class="col-md-3" *ngIf="!isInfinite">{{ packCount }}</div>
      <div class="col-md-3" *ngIf="isInfinite">
        <span class="infinite-font rc-value">&infin;</span>
      </div>
      <div class="col-md-3"><strong>{{ 'packsTexts.orderDate' | translate }}:</strong></div>
      <div class="col-md-3">{{ packData.order.orderDate | date: dateFormat }}</div>
    </div>
    <mat-divider *ngIf="!showMPIResponse"></mat-divider>

    <mat-card-content *ngIf="!showMPIResponse" class="container">
      <h2>{{ 'packsTexts.payment' | translate }}</h2>
      <div *ngIf="awaitingPayment">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
      <div class="container" *ngIf="awaitingPayment"><br>
        {{ cardPaymentDescription | translate }}
        <button *ngIf="showPaymentButton" mat-raised-button (click)="onCancelPayment();" [disabled]="!paymentInitiated"
          color="primary">
          {{'packsTexts.cancelOrder' | translate}}
        </button>
      </div>

      <mat-tab-group *ngIf="!awaitingPayment">
        <mat-tab>
          <ng-template mat-tab-label>
            <cqes-icon icon="payment"></cqes-icon>
            {{ 'packsTexts.withCard' | translate }}
          </ng-template>
          <div class="container">{{ cardPaymentDescription | translate }}</div>
          <div class="row-button">
            <button *ngIf="showPaymentButton" mat-raised-button (click)="onInitiatePayment()" color="primary"
              [disabled]="paymentInitiated">
              {{'packsTexts.makePayment' | translate}}
            </button>
            <button *ngIf="!showPaymentButton" mat-raised-button (click)="backAfterSuccessfullyPayment()"
              color="primary">
              {{'packsTexts.back' | translate}}
            </button>
          </div>
          <div class="row row-logos">
            <div class="logo-container">
              <img src="../assets/images/logos/B-card_logo_b-secured_green.svg" alt="Bcard logo">

            </div>
            <div class="logo-container">
              <img src="../assets/images/logos/visa-secure_blu_2021_rgb.svg" alt="Visa Secure logo">
            </div>
            <div class="logo-container">
              <img src="../assets/images/logos/mc_idcheck_vrt_rgb_pos.svg" alt="Mastercard logo">

            </div>
            <div class="logo-container">
              <img src="../assets/images/logos/DN_DCI_protect_buy_logo.png" alt="DN DCI ProtectBuy logo">
            </div>
          </div>
          <div class="terms-pay">
            <a href="https://www.b-trust.bg/attachments/BtrustDocument/141/docs/Obshti-usloviya-za-prodajba-prez-elektronen-kanal-na-BORIKA-AD-april-2022.pdf"
              target="_blank">
              {{'terms' | translate}}</a>
          </div>
        </mat-tab>
      </mat-tab-group>

    </mat-card-content>


    <mat-card-content *ngIf="showMPIResponse" class="container">
      <div class="row" *ngIf="showPaymentInWaiting">
        {{ 'packsTexts.orderNum' | translate }} {{ paymentDataStatus.orderNumber }} {{ 'packsTexts.orderInProgress' |
        translate }}...
      </div>
      <div class="row" *ngIf="!showPaymentInWaiting">
        <div class="col-md-3"><strong>{{ 'packsTexts.orderNum' | translate }}:</strong></div>
        <div class="col-md-3">{{ paymentDataStatus.orderNumber }}</div>
      </div>
      <div class="row" *ngIf="!showPaymentInWaiting">
        <div class="col-md-3"><strong>{{ 'packsTexts.fromDate' | translate }}:</strong></div>
        <div class="col-md-5">{{ paymentDataStatus.formattedTransactionDate }}</div>
      </div>
      <div class="row" *ngIf="!showPaymentInWaiting">
        <div class="col-md-3"><strong>{{ 'packsTexts.orderPrice' | translate }}:</strong></div>
        <div class="col-md-3">
            <ng-container *ngIf="packData.order?.currencyCode">
                <span [ngClass]="{ 'hide': packData.order.currencyCode === 'EUR' }"
                  *ngIf="packData.order.currencyCode === 'BGN'">
                  {{ packData.order.price | localizedCurrency }} / {{ (packData.order.price / 1.95583) | currency:'EUR':'symbol':'1.2-2':'de-DE' }}
                </span>
                <span *ngIf="packData.order.currencyCode === 'EUR'">
                  {{ packData.order.price | currency:'EUR':'symbol':'1.2-2':'de-DE'}} / {{ (packData.order.price * 1.95583) | currency:'BGN':'symbol':'1.2-2':'bg-BG' }}
                </span>
              </ng-container>
        </div>
      </div>
      <div class="row" *ngIf="!showPaymentInWaiting">
        <div class="col-md-3"><strong>{{ 'packsTexts.cardPaymentStatus' | translate }}:</strong></div>
        <div class="col-md-7">{{ paymentDataStatus.transactionStatus }}</div>
      </div>
      <div class="row" *ngIf="!showPaymentInWaiting && !isBlank(paymentDataStatus.cardHolderInfo)">
        <div class="col-md-3"><strong>{{ 'packsTexts.cardHolderInfo' | translate }}:</strong></div>
        <div class="col-md-7">{{ paymentDataStatus.cardHolderInfo }}</div>
      </div>
      <br /><br />
      <div class="row" *ngIf="!showPaymentInWaiting && paymentDataStatus.statusCode==='OK'">
        <div class="col-md-6"><strong>{{ 'packsTexts.thankYouForChoosingUs' | translate }}</strong></div>
        <div class="col-md-3"></div>
      </div>
      <br /><br />
      <div class="row" *ngIf="!showPaymentInWaiting && paymentDataStatus.statusCode==='OK'">
        <div class="col-md-6">{{ 'packsTexts.contactWithBorica' | translate }}:</div>
        <div class="col-md-3"></div>
      </div>
      <div class="row" *ngIf="!showPaymentInWaiting && paymentDataStatus.statusCode==='OK'">
        <div class="col-md-6">0700 199 10 {{ 'packsTexts.or' | translate }} *9910</div>
        <div class="col-md-3"></div>
      </div>
      <div class="row" *ngIf="!showPaymentInWaiting && paymentDataStatus.statusCode==='OK'">
        <div class="col-md-3">e-mail:</div>
        <div class="col-md-3"><a href="mailto:support@borica.bg">support@borica.bg</a></div>
      </div>
    </mat-card-content>
  </mat-card-content>
</mat-card>